var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHotlineMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26,2v2c9.9248047,0,18,8.0751953,18,18h2C46,10.9716797,37.0283203,2,26,2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,22h2c0-7.7197266-6.2802734-14-14-14v2C32.6171875,10,38,15.3828125,38,22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,22h2c0-4.4111328-3.5888672-8-8-8v2C29.3085938,16,32,18.6914062,32,22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4140625,29C35.125,27.7109375,32.875,27.7109375,31.5859375,29l-3.2929688,3.2929688 c-2.0869141,2.0859375-7.5283203,1.0585938-10.5859375-2c-3.0585938-3.0585938-4.0859375-8.5-2-10.5859375L19,16.4140625 C19.6445312,15.7695312,20,14.9121094,20,14s-0.3554688-1.7695312-1-2.4140625L13.4140625,6 C12.125,4.7109375,9.875,4.7109375,8.5859375,6C6.5,8.0859375,3,12.4189453,3,18 c0,5.1494141,0.9853516,11.3994141,8.2929688,18.7070312S24.8505859,45,30,45c5.5810547,0,9.9140625-3.5,12-5.5859375 C42.6445312,38.7695312,43,37.9121094,43,37s-0.3554688-1.7695312-1-2.4140625L36.4140625,29z M40.5859375,38 C38.71875,39.8671875,34.8603516,43,30,43c-4.7402344,0-10.5009766-0.9160156-17.2929688-7.7070312 C5.9160156,28.5009766,5,22.7402344,5,18c0-4.8603516,3.1328125-8.71875,5-10.5859375C10.2675781,7.1474609,10.6220703,7,11,7 s0.7324219,0.1474609,1,0.4140625L17.5859375,13C17.8525391,13.2675781,18,13.6220703,18,14s-0.1474609,0.7324219-0.4140625,1 l-3.2929688,3.2929688c-2.8798828,2.8798828-1.8896484,9.5244141,2,13.4140625 c3.890625,3.8896484,10.5332031,4.8798828,13.4140625,2L33,30.4140625c0.5351562-0.5332031,1.4648438-0.5332031,2,0L40.5859375,36 C40.8525391,36.2675781,41,36.6220703,41,37S40.8525391,37.7324219,40.5859375,38z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotlineMedium);
export default __webpack_public_path__ + "static/media/hotline--medium.69d72f6a4a6423277c9d08625d3c87e4.svg";
export { ForwardRef as ReactComponent };